import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
// Translations
import { useTranslation } from "react-i18next"

const SaveNewSearch = ({
	saveQueryData,
	setSaveQueryData,
	shareRefresh,
	setTotalPagesSavedConcepts,
	calcTotalPagesSavedConcepts,
	setTotalPagesSharedConcepts,
	calcTotalPagesSharedConcepts,
	// setSearchReducer,
	setShowToSaveForm,
	saveSearch,
	setShareRefresh,
	isAnyDataLoaded = false,
	isTimeline = false,
}) => {
	/* ******************* TRANSALATIONS ******************* */
	const [t, i18n] = useTranslation("global")
	/* ******************* END TRANSALATIONS ******************* */

	/* ******************* REDUX STORE ******************* */
	const selectedSearch = useSelector((state) => state.savedSearch?.selectedSearch)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	const disabledCondition = isTimeline ? !isAnyDataLoaded : saveQueryData.name === ""

	return (
		<Fragment>
			{isAnyDataLoaded && (
				<div className="col-12 mt-4 d-flex align-items-center">
					<div className="col-2 divQuerySearch inline-block">
						<input
							id="saveSearch"
							type="text"
							name="saveSearch"
							className="saveConceptInput height-35"
							style={{ margin: "0" }}
							placeholder={t("search.query_name")}
							value={saveQueryData.name || selectedSearch?.name}
							onChange={(e) => {
								e.preventDefault()
								if (!_.isEmpty(saveQueryData)) {
									setSaveQueryData({ ...saveQueryData, name: e.target.value })
								} else if (!_.isEmpty(selectedSearch)) {
									setSaveQueryData({ ...selectedSearch, name: e.target.value })
								}
							}}
						/>
					</div>
					<div className="col-1 divQuerySearch inline-block">
						<div className="form-check d-flex align-items-center" style={{ gap: 5 }}>
							<input
								key={`shared_checkbox_${shareRefresh}`}
								data-cy="checkbox_Share_Concept"
								className="form-check-input"
								type="checkbox"
								value=""
								id="shareCheckbox"
								// defaultChecked={saveQueryData.share}
								defaultChecked={0}
								onClick={(e) => {
									setSaveQueryData({
										...saveQueryData,
										share: saveQueryData.share === 1 ? 0 : 1,
									})
								}}
							/>
							<label className="form-check-label" htmlFor="shareCheckbox">
								{t("search.share_search")}
							</label>
						</div>
					</div>
					<div className="col-1 divQuerySearch inline-block" style={{ marginRight: "20px", marginLeft: "20px" }}>
						<button
							data-cy="load_button"
							className="btn btn-outline-primary btn-sm height-35 w100"
							disabled={disabledCondition}
							onClick={(e) => {
								e.preventDefault()
								setTotalPagesSavedConcepts(calcTotalPagesSavedConcepts)
								setTotalPagesSharedConcepts(calcTotalPagesSharedConcepts)
								// setSearchReducer();
								setShowToSaveForm(false)
								saveSearch()
							}}
						>
							{selectedSearch?.id ? t("search.update") : t("search.save")}
						</button>
					</div>
					<div className="col-1 divQuerySearch inline-block">
						<button
							data-cy="cancel_load_button"
							className="btn btn-outline-primary btn-sm height-35 w100"
							onClick={(e) => {
								e.preventDefault()
								setSaveQueryData({ name: "", share: 0, id: "" })
								setShareRefresh(Math.random())
								setShowToSaveForm(false)
							}}
						>
							{t("search.cancel")}
						</button>
					</div>
				</div>
			)}
		</Fragment>
	)
}

export default SaveNewSearch
